<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      user: {
        id: "",
        name: "",
        email: "",
        country_code: "",
        phone: "",
        about: "",
        user_inventment_asset: "",
        user_inventment_style: "",
        user_inventment_type: "",
      },
      title: "Users",
      disabled: false,
      items: [
        {
          text: "user",
          href: "/users",
        },
        {
          text: "View",
          active: true,
        },
      ],
      assetTable: {
        width: "750px",
      },
      styleTable: {
        width: "750px",
      },
      typeTable: {
        width: "750px",
      },
      investmentTable: {
        margin_top: "30px",
      },
    };
  },
  computed: mapGetters("user", [
    "loading",
    "userCount",
    "userData",
    "users",
    "paginations",
  ]),
  mounted() {
    let id = this.$route.params.id;

    this.showUserName(id);
  },
  methods: {
    ...mapActions("user", ["showFollowerUser", "updateUser"]),
    showUserName(id) {
      this.showFollowerUser(id).then((res) => {
        this.user.id = res.id;
        this.user.name = res.name;
        this.user.email = res.email;
        this.user.country_code = res.country_code;
        this.user.phone = res.phone_number;
        this.user.about = res.about;
        this.user.user_inventment_asset = res.user_inventment_asset;
        this.user.user_inventment_style = res.user_inventment_style;
        this.user.user_inventment_type = res.user_inventment_type;
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="text-left mb-4">
          <a href="#" class="router-link-active" @click="$router.back()">
            <i class="bx bx-arrow-back"></i>
            Back
          </a>
        </div>
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon" style="display: flex">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ user.name }}</h4>
              <p>
                <router-link :to="{ name: 'user.list' }">User</router-link>
                > {{ user.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form>
              <div class="row">
                <input type="hidden" class="form-control" name="id" v-model="user.id" />
                <div class="col-sm-6">
                  <label>Email </label><br />
                  <div class="form-group" v-if="user.email">
                    <span for="name"> {{ user.email }}</span>
                  </div>
                  <div class="form-group" v-else>
                    <span>-</span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <label>Country Code </label><br />
                  <div class="form-group" v-if="user.country_code">
                    <span for="short_about">{{ user.country_code }}</span>
                  </div>
                  <div class="form-group" v-else>
                    <span>-</span>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-sm-6">
                  <label>Phone Number</label><br />
                  <div class="form-group" v-if="user.phone">
                    <span for="phone">{{ user.phone }}</span>
                  </div>
                  <div class="form-group" v-else>
                    <span>-</span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <label>About</label><br />
                  <div class="form-group" v-if="user.about">
                    <span for="about">{{ user.about }}</span>
                  </div>
                  <div class="form-group" v-else>
                    <span>-</span>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-sm-12">
                  <label>Investment Assets</label><br />
                  <div
                    class="form-group d-flex"
                    v-if="user.user_inventment_asset.length > 0"
                  >
                    <div
                      v-for="value in user.user_inventment_asset"
                      v-bind:key="value.id"
                    >
                      <span class="badge rounded-pill badge-dark ml-2">{{
                        value.name
                      }}</span>
                    </div>
                  </div>
                  <div clas="col-12 mb-2" v-else><span>-</span></div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-sm-12">
                  <label>Investment Styles</label><br />
                  <div
                    class="form-group d-flex"
                    v-if="user.user_inventment_style.length > 0"
                  >
                    <div
                      v-for="value in user.user_inventment_style"
                      v-bind:key="value.id"
                    >
                      <span class="badge rounded-pill badge-dark ml-2">{{
                        value.name
                      }}</span>
                    </div>
                  </div>
                  <div clas="col-12 mb-2" v-else><span>-</span></div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-sm-12">
                  <label>Investment Types</label><br />
                  <div
                    class="form-group d-flex"
                    v-if="user.user_inventment_type.length > 0"
                  >
                    <div v-for="value in user.user_inventment_type" v-bind:key="value.id">
                      <span class="badge rounded-pill badge-dark ml-2">{{
                        value.name
                      }}</span>
                    </div>
                  </div>
                  <div clas="col-12 mb-2" v-else><span>-</span></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
